import { Dispatch } from 'redux'

import { useThunkActions } from 'redux/actions/useThunkActions'

import { update } from 'redux/api/Accounts'
import { getAll, getNps, getOne } from 'redux/api/internal/Accounts'

import { ApplicationState } from 'redux/Stores/types'

import { PatchAccountBody } from 'types/GlobalAccount'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import { toggleSnackbarOpen } from '../../Snackbar'

import * as actions from './actions'

function tryGetAllAccounts() {
  return (dispatch: Dispatch, getState: () => ApplicationState) => {
    const { fetchStatus } = getState().InternalAccountStore

    if (fetchStatus === 'fetching' || fetchStatus === 'success') {
      return
    }

    dispatch(actions.getAll())

    getAll()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

function tryGetOneAccount(id: string, callback?: (err?: boolean) => void) {
  return (dispatch: Dispatch) => {
    getOne(id)
      .then((response) => {
        dispatch(actions.getOneSuccess(response.data.data))

        callback?.()
      })
      .catch(() => {
        callback?.(true)
      })
  }
}

function tryGetAccountNps(id: string, callback?: (err?: boolean) => void) {
  return (dispatch: Dispatch) => {
    getNps(id)
      .then((response) => {
        dispatch(actions.getNpsSuccess({ id, periods: response.data.data }))

        callback?.()
      })
      .catch(() => {
        callback?.(true)
      })
  }
}

/** Saved as any other account, then read back in its internal shape. */
function tryUpdateAccount(
  id: string,
  body: PatchAccountBody,
  callback?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    update(id, body)
      .then(() => getOne(id))
      .then((response) => {
        dispatch(actions.getOneSuccess(response.data.data))
        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))

        callback?.()
      })
      .catch(() => {
        callback?.(true)
      })
  }
}

export const useInternalAccountActions = () => {
  return {
    tryGetAccountNps: useThunkActions(tryGetAccountNps),
    tryGetAllAccounts: useThunkActions(tryGetAllAccounts),
    tryGetOneAccount: useThunkActions(tryGetOneAccount),
    tryUpdateAccount: useThunkActions(tryUpdateAccount)
  }
}
